const STORAGE_KEY = 'webappz.telegramFullscreenMode';
const FULLSCREEN_MODE = 'fullscreen';
const COMPACT_MODE = 'compact';

export const getTelegramFullscreenMode = () => {
    try {
        const mode = window.localStorage.getItem(STORAGE_KEY);

        if (mode === FULLSCREEN_MODE || mode === COMPACT_MODE) {
            return mode;
        }
    } catch {
    }

    return null;
};

export const setTelegramFullscreenMode = (mode) => {
    if (mode !== FULLSCREEN_MODE && mode !== COMPACT_MODE) {
        return;
    }

    try {
        window.localStorage.setItem(STORAGE_KEY, mode);
    } catch {
    }
};

export const isTelegramFullscreenMode = () => getTelegramFullscreenMode() === FULLSCREEN_MODE;

export const applyTelegramFullscreenMode = (webApp) => {
    if (!webApp) {
        return;
    }

    const mode = getTelegramFullscreenMode();

    try {
        if (mode === FULLSCREEN_MODE) {
            if (typeof webApp.expand === 'function') {
                webApp.expand();
            }

            if (typeof webApp.requestFullscreen === 'function') {
                webApp.requestFullscreen();
            }
        }

        if (mode === COMPACT_MODE && webApp.isFullscreen && typeof webApp.exitFullscreen === 'function') {
            webApp.exitFullscreen();
        }
    } catch {
    }
};

export const toggleTelegramFullscreenMode = (webApp) => {
    const currentMode = getTelegramFullscreenMode();
    const nextMode = currentMode === FULLSCREEN_MODE || (currentMode === null && webApp && webApp.isFullscreen)
        ? COMPACT_MODE
        : FULLSCREEN_MODE;

    setTelegramFullscreenMode(nextMode);
    applyTelegramFullscreenMode(webApp);

    return nextMode;
};
